import { ContratoStatus, VersaoContratoEnum } from 'models/contratos';
import { Action, ContratosEntePublicoReducerState } from './__types';
import {
  CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION,
  CLEAR_COD_COOP_ENTE_PUBLICO_ACTION,
  CLEAR_CONTRATO_ENTE_PUBLICO_STATUS_GLOBAL_ACTION,
  CLEARED_CONTRATO_ENTE_PUBLICO_ACTION,
  CLOSE_MODAL_ENTE_PUBLICO_ADITIVO_ACTION,
  CLOSE_MODAL_ENTE_PUBLICO_DISTRATO_ACTION,
  LOADED_CONTRATO_ENTE_PUBLICO_ACTION,
  OPEN_MODAL_ENTE_PUBLICO_ADITIVO_ACTION,
  OPEN_MODAL_ENTE_PUBLICO_DISTRATO_ACTION,
  SET_CONTRATO_ID_ENTE_PUBLICO_ACTION
} from './EntePublicoActions'


const ADENDO_EDITING_INITIAL_STATE = {
  id: null,
  flgStatus: 0,
  versaoContrato: 1,
  codigo: '',
  ativo: false,
  idDocAssinado: null,
  idDocNaoAssinado: null,
  idDocExtrato: null,
  idDocPlanoTrabalho: null,
  extensaoDocAssinado: null,
  extensaoDocNaoAssinado: null,
  extensaoDocExtrato: null,
  extensaoDocPlanoTrabalho: null,
  dataAlteracao: '',
  incluiPlanoTrabalho: false
};

const ADENDO = {
  adendos: [ADENDO_EDITING_INITIAL_STATE],
  flgStatus: 0,
  geraAditivo: false,
  geraDistrato: false,
  idContrato: null,
  incluiPlanoTrabalho: false
};

const CONTRATO_EDITING_INITIAL_STATE = {
  codCoop: '',
  dataFim: '',
  dataInicio: '',
  emailCoop: '',
  flgAnaliseJuridica: false,
  idEstado: 0,
  nomCidade: '',
  totalMeses: 0,
  programasEducacionais: [],
  flgStatus: ContratoStatus.EM_EDICAO,
  idContrato: null,
  flgAtivo: true,
  versaoContrato: VersaoContratoEnum.CONTRATO,
  dataDistrato: '',
  tipoContrato: 0
};

const INITIAL_STATE: ContratosEntePublicoReducerState = {
  contratoEditing: CONTRATO_EDITING_INITIAL_STATE,
  adendoEditing: ADENDO_EDITING_INITIAL_STATE,
  adendoObject: ADENDO,
  adendosAll: [],
  statusDefinitivo: 0,
  isModalAditivoOpen: false,
  isModalDistratoOpen: false,
};

export default function contratosDescentralizadosEntePublicoReducer(
  state: ContratosEntePublicoReducerState = INITIAL_STATE,
  action: Action
): ContratosEntePublicoReducerState {
  switch (action.type) {
    case CLEAR_COD_COOP_ENTE_PUBLICO_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          codCoop: '',
        },
      };
    case CLEARED_CONTRATO_ENTE_PUBLICO_ACTION:
      return {
        ...state,
        contratoEditing: CONTRATO_EDITING_INITIAL_STATE,
      };
    case CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case SET_CONTRATO_ID_ENTE_PUBLICO_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          idContrato: action.payload,
        },
      };
    case LOADED_CONTRATO_ENTE_PUBLICO_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...CONTRATO_EDITING_INITIAL_STATE,
          ...action.payload,
        },
      };
    case CLEAR_CONTRATO_ENTE_PUBLICO_STATUS_GLOBAL_ACTION:
      return {
        ...state,
        statusDefinitivo: INITIAL_STATE.statusDefinitivo,
      };
    case OPEN_MODAL_ENTE_PUBLICO_ADITIVO_ACTION:
      return { ...state, isModalAditivoOpen: true };
    case OPEN_MODAL_ENTE_PUBLICO_DISTRATO_ACTION:
      return { ...state, isModalDistratoOpen: true };
    case CLOSE_MODAL_ENTE_PUBLICO_ADITIVO_ACTION:
      return { ...state, isModalAditivoOpen: false };
    case CLOSE_MODAL_ENTE_PUBLICO_DISTRATO_ACTION:
      return { ...state, isModalDistratoOpen: false };
    default:
      return state;
  }
}
